import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPieChartActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.2)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "pie",
			children: [/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 1172",
				opacity: .4,
				cx: 9,
				cy: 11,
				r: 9,
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Ellipse 406",
				d: "M19.8025 8.01276C19.0104 4.08418 15.9158 0.989547 11.9872 0.197443C10.9045 -0.0208739 10 0.89542 10 1.99999V7.99999C10 9.10456 10.8954 9.99999 12 9.99999H18C19.1046 9.99999 20.0209 9.09554 19.8025 8.01276Z",
				fill: "currentColor"
			})]
		})
	})]
});
const ForwardRef = forwardRef(SvgPieChartActive);
export default ForwardRef;
